function LPMainTop() {
    const client_version = process.env.REACT_APP_CLIENT_VERSION;

    const handleDownload = async () => {
        window.location.assign('/downloads/LiveTelemetry.exe');
    };
    
    return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
            <div className="absolute inset-0 bg-gradient-to-b from-background-dark/60 via-background-dark/80 to-background-dark z-10"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-background-dark via-transparent to-background-dark z-10"></div>
            <div className="w-full h-full bg-cover bg-center" data-alt="Dark cinematic GT3 race car on track with motion blur" style={{backgroundImage: "url('https://lh3.googleusercontent.com/aida-public/AB6AXuCDOboZ4bOENJdI2xFNkvFFKeA9ifY5MWTiWjSjGjIp2S5E-Dmj9GMu3bgBtboNPZ-AwVtO1DuSKFHsTBjCmy07ikvORftpq9FfGjh7Ut4s3kaQuThUnApd1RpgzMek3GS_oa_yhqfLwujfU8F0cwUjVDm9AbjMofqu7AaI8G44S9uK7BqlOk4O-JE_bwAu_tCv2sl4FIAOoWjRJ71Ep6xWc0hGV7F6JFiRgPg6tWoA8wpYHAQjwzVr3bO5d0S7xICYUhG9FSqIUKg')"}}></div>
        </div>

        <div className="relative z-20 max-w-4xl mx-auto px-6 text-center">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 mb-8">
                <span className="relative flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent-cyan opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-accent-cyan"></span>
                </span>

                <span className="text-[10px] uppercase tracking-widest font-bold text-accent-cyan">Live v{client_version} Client Active</span>
            </div>

            <h1 className="text-5xl md:text-7xl font-black text-white leading-[1.1] tracking-tight mb-6 uppercase italic">Real-Time Precision for the <span className="text-primary">Virtual Track</span></h1>
            <p className="text-lg md:text-xl text-slate-300 max-w-2xl mx-auto mb-10 leading-relaxed font-light">The ultimate telemetry suite for Assetto Corsa Competizione drivers and teams. Gain the competitive edge with millisecond precision and live engineering support.</p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <button className="w-full sm:w-auto min-w-[200px] h-14 bg-primary hover:bg-primary/90 text-white font-bold rounded-lg text-lg transition-all glow-blue flex items-center justify-center gap-2" onClick={handleDownload}>Download Client <span className="material-symbols-outlined">download</span></button>
                <button className="w-full sm:w-auto min-w-[200px] h-14 bg-white/5 hover:bg-white/10 border border-white/10 text-white font-bold rounded-lg text-lg transition-all backdrop-blur-sm">Watch Live Demo</button>
            </div>
        </div>

        <div className="absolute bottom-10 right-10 hidden lg:block">
            <div className="glass-panel p-4 rounded-xl w-64">
                <div className="flex justify-between items-center mb-4">
                    <span className="text-[10px] text-slate-400 uppercase font-bold">Telemetry Preview</span>
                    <span className="text-[10px] text-accent-red font-bold">RECORDING</span>
                </div>

                <div className="space-y-3">
                    <div className="flex justify-between">
                        <span className="text-xs text-slate-300">Tire Temp (FL)</span>
                        <span className="text-xs text-accent-cyan font-bold">88.4°C</span>
                    </div>

                    <div className="w-full bg-white/5 h-1 rounded-full overflow-hidden">
                        <div className="bg-accent-cyan h-full w-[70%]"></div>
                    </div>

                    <div className="flex justify-between">
                        <span className="text-xs text-slate-300">Brake Pressure</span>
                        <span className="text-xs text-primary font-bold">92%</span>
                    </div>
                    
                    <div className="w-full bg-white/5 h-1 rounded-full overflow-hidden">
                        <div className="bg-primary h-full w-[92%] shadow-[0_0_8px_#137fec]"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    );
}

export default LPMainTop;